import { ItemStateModel } from "./item-state.model";
import { ReviewSet } from "./review-set.model";

export class ReviewSetState extends ItemStateModel {
    reviewSets: ReviewSet[];
    caseReviewSetCount: number;
}
